import { useCallback, useMemo } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { parseQuery, stringifyQuery } from '../utils'

export default function useSearchParams() {
  const location = useLocation()
  const history = useHistory()

  const search = useMemo(
    () => parseQuery(location.search),
    [location.search]
  )

  const updateSearch = useCallback((update, options = {}) => {
    const { replace, ...state } = options

    history[replace ? 'replace' : 'push']({
      search: stringifyQuery(update),
      state,
    })
  }, [history])

  return [search, updateSearch]
}
